<template lang="">
    <div class="page-header">
        {{title}}
    </div>
</template>
<script>
export default {
    props: {
        title: String
    }
}
</script>
<style scoped>
    .page-header{
        padding:0.5rem 0.9rem;
        font-size:2rem;
        /* font-weight: bold; */
        color:var(--page-header);
        font-family:var(--page-header-font);

    }

    @media(max-width:768px){
        .page-header{
            font-size:1.2rem;
            font-weight:bold;
            
        }
    }
</style>